<template>
  	<div class="toast-c" v-if="show">
		<img v-if="successIcon" src="../images/icon_success.png"/>
		{{msg}}
		<span v-if="richText" v-html="richText"></span>
	</div>
</template>

<script>
export default {
	name: "Toast2",
}
</script>

<style lang="less" scoped>
.toast-c {
	display: flex;
	align-items: center;
	position: fixed;
	top: 50%;
	left:50%;
	font-size:16px;
	transform: translate(-50% , -50%);
	z-index: 667;
	height: 50px;
	background: rgba(0, 0, 0, 0.7);
	color: white;
	padding: 0 18px;
	border-radius: 2px;
	img {
		width: 22px;
		height: 22px;
		margin-right: 8px;
	}
}
</style>
